import React from "react";
import { useLocation } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { GHL_CALENDAR_URL, externalLinkProps } from "../config/ghl";

export const StickyMobileCta = () => {
  const { t } = useI18n();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <div className="md:hidden fixed bottom-4 inset-x-0 z-40 flex justify-center px-6 pointer-events-none">
      <a
        href={GHL_CALENDAR_URL}
        {...externalLinkProps}
        data-testid="mobile-sticky-cta"
        className="btn-cta pointer-events-auto inline-flex items-center gap-2 text-sm font-semibold px-6 py-3 rounded-full shadow-[0_8px_30px_rgba(4,9,22,0.55)]"
      >
        <CalendarClock size={15} />
        {t.nav.bookDemo}
      </a>
    </div>
  );
};
